import { defineMessages } from "react-intl";

const messages = defineMessages({
  returnInput: {
    id: "combinedPicker.return",
    description: "The return date label",
    defaultMessage: "+ Add return",
  },
  returnLabel: {
    id: "combinedPicker.returnMobile",
    description: "The return date label",
    defaultMessage: "Return",
  },
  departureInput: {
    id: "combinedPicker.departure",
    description: "The departure date label",
    defaultMessage: "Add departure",
  },
  departureLabel: {
    id: "combinedPicker.departureMobile",
    description: "The departure date label",
    defaultMessage: "Depart",
  },
  doneButton: {
    id: "combinedPicker.done",
    description: "The done selecting dates button label",
    defaultMessage: "Done",
  },
  selectReturnPrompt: {
    id: "combinedPicker.selectReturnPrompt",
    description: "The prompt to select a return date",
    defaultMessage: "Select a new return date",
  },
  placeholder: {
    id: "combinedPicker.placeholder",
    description: "The placeholder for the date inputs",
    defaultMessage: "Add dates",
  },
  newNotification: {
    id: "combinedPicker.newNotification",
    description: "Notification for new date selection feature",
    defaultMessage: "New! Select dates here in your search.",
  },
  findTickets: {
    id: "ticketPicker.findTickets",
    description: "Text on the submit button when searching for a ticket.",
    defaultMessage: "Find tickets",
  },
  findFlights: {
    id: "ticketPicker.findFlights",
    description:
      "Text on the submit button when searching for a flight ticket.",
    defaultMessage: "Find flights",
  },
});

export default messages;
